import requests from "./httpService";

const AdminServices = {
  loginAdmin(body) {
    return requests.post(`/user/login`, body);
  },
  ChangeAdminPassword(body) {
    return requests.put(`/user/change_password`, body);
  },
};

export default AdminServices;
